import React, { useEffect, useState } from "react";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";

import { GoPlusCircle } from "react-icons/go";

import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import { Link } from "react-router-dom";
import { Button, message, Modal, Popconfirm, Skeleton, Tooltip } from "antd";
import YukXatiHeader from "../../../Components/YukXati/YukXatiHeader";
import moment from "moment";

export default function YukXatiKirim() {
  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(false);
  const messageApi = useMessage();

  let getKirim = async () => {
    try {
      setLoading(true);

      let { data } = await axiosInstance.get("/api/kirim");
      if (data.success) {
        console.log("data");
        console.log(data);
        setData(data);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          target="_blank"
          rel="noopener noreferrer"
          href="/checkUser"
        >
          <GoPlusCircle className="font-[30px]" /> Yuk xati
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          target="_blank"
          rel="noopener noreferrer"
          href="/customers"
        >
          Xaridorlar
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          target="_blank"
          rel="noopener noreferrer"
          href="/yukxati/kirim"
        >
          Kirimlar
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          target="_blank"
          rel="noopener noreferrer"
          href="/yukxati/kirim"
        >
          kirim qo'shish
        </Link>
      ),
    },
  ];

  useEffect(() => {
    getKirim();
  }, []);

  const copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      messageApi.open({
        type: "success",
        content: text + " Copied!",
      });
    } catch (err) {
      messageApi.open({
        type: "success",
        content: "Failed to copy!",
      });
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isOne, setIsOne] = useState(null);

  const confirm = async (el) => {
    try {
      console.log(el);
      setIsDeleting(true);
      let { data } = await axiosInstance.delete("/api/kirim/" + el.id);
      console.log(data);
      getKirim();
      message.success(el.name + " O'chdi");

      setIsModalOpen(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsDeleting(false);
    }
  };

  // loading
  if (loading) {
    return (
      <div className="pb-[50px]">
        <YukXatiHeader PageTitle={"Yukxati Kirimlar"} />

        <div className="w-[100%] flex flex-col items-start md:gap-2 overflow-auto">
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
          <div className=" min-w-[900px] my-1 m-auto  shrink-0 max-w-[900px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start content-center items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 ">
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
            <Skeleton.Input
              active
              size="small"
              className=" text-[14px] text-[#111827] p-0 m-0 w-[30px] "
            />
          </div>
        </div>
      </div>
    );
  }

  if (data?.data?.length == 0) {
    return (
      <div>
        <YukXatiHeader PageTitle={"Yukxati Kirimlar"} />
        <main class="grid  place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div class="text-center">
            {/* <p class="text-base font-semibold text-indigo-600">404</p>
            <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
              Page not found
            </h1> */}
            <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Kirim mavjud emas
            </p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/yukxati/kirim/new"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Kirim qo'shish
              </Link>
              <Link to="/yukxati/" class="text-sm font-semibold text-gray-900">
                Asosiy sahifa <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <YukXatiHeader PageTitle={"Yukxati Kirimlar"} />
      <div className="pb-[70px] overflow-auto">
        {/* <YukXatiList data={data?.data} /> */}
        <Modal
          style={{ top: 20 }}
          title={`Kirimni ${isOne?.written_by} yozgan!`}
          open={isModalOpen}
          // loading
          onOk={() => {
            setIsModalOpen(false);
          }}
          onCancel={() => {
            setIsModalOpen(false);
          }}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                setIsModalOpen(false);
              }}
            >
              Ok
            </Button>,
          ]}
        >
          {isOne ? (
            <div className="relative flex flex-col gap-1 text-[16px] ">
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => {
                  confirm(isOne);
                }}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  loading={isDeleting}
                  className="absolute top-0 right-0"
                  danger
                >
                  Delete
                </Button>
              </Popconfirm>

              <p
                className="text-[16px] m-0 p-0"
                onClick={() => {
                  copyContent(isOne.customer_name);
                }}
              >
                Kimdan: {isOne.customer_id}. {isOne.customer_name}
              </p>
              <p
                className="text-[16px] m-0 p-0"
                onClick={() => {
                  copyContent(isOne.auto_number);
                }}
              >
                auto: {isOne.auto_number}
              </p>
              <p
                className="text-[16px] m-0 p-0"
                onClick={() => {
                  copyContent(isOne.driver_name);
                }}
              >
                Xaydovchi: {isOne.driver_name}
              </p>
              <p
                className="text-[16px] m-0 p-0"
                onClick={() => {
                  copyContent(isOne.where_to);
                }}
              >
                Qayerga: {isOne.where_to}
              </p>
              <p
                className="text-[16px] m-0 p-0"
                onClick={() => {
                  copyContent(moment(isOne.created_at).format("DD.MM.YYYY"));
                }}
              >
                sana: {moment(isOne.created_at).format("DD.MM.YYYY")}
              </p>
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                }}
                border="1"
                className="text-[14px]"
              >
                <tr>
                  <th
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                    className="text-[14px] text-left text-bold border border-gray-400 px-1 py-1"
                  >
                    Юк номи
                  </th>
                  <th
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                    className="text-[14px] text-left text-bold border border-gray-400 px-1 py-1"
                  >
                    Tn
                  </th>
                  <th
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                    className="text-[14px] text-left text-bold border border-gray-400 px-1 py-1"
                  >
                    Qop
                  </th>
                  <th
                    style={{
                      fontSize: "14px",
                      margin: 0,
                    }}
                    className="text-[14px] text-left text-bold border border-gray-400 px-1 py-1"
                  >
                    (1 qop ) Narxi
                  </th>
                </tr>

                <tr
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  <td
                    style={{
                      fontSize: "14px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "14px",
                      padding: "4px",
                    }}
                    className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                  >
                    {isOne.name}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "14px",
                      padding: "4px",
                    }}
                    className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                  >
                    {isOne.tonna}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "14px",
                      padding: "4px",
                    }}
                    className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    onClick={() => {
                      copyContent((isOne.tonna * 1000) / 50);
                    }}
                  >
                    {(isOne.tonna * 1000) / 50}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      margin: 0,
                      padding: 0,
                      paddingLeft: "4px",
                      lineHeight: "14px",
                      padding: "4px",
                    }}
                    className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1"
                    onClick={() => {
                      copyContent((isOne.tonna * 1000) / 50);
                    }}
                  >
                    {isOne.price_qop}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-[14px] text-left text-bold border border-gray-400 px-1 py-1">
                    {isOne.price_qop * ((isOne.tonna * 1000) / 50)}
                  </td>
                </tr>
              </table>
              <p
                className="text-[16px] m-0 p-0"
                onClick={() => {
                  copyContent(isOne.comment);
                }}
              >
                izox: {isOne.comment}
              </p>
            </div>
          ) : null}
        </Modal>
        <div className="max-w-[900px] w-[99%] shrink flex flex-col items-center gap-1 m-auto ">
          {data?.data?.map((el) => {
            console.log(el);
            return (
              <div
                onContextMenu={(e) => {
                  e.preventDefault();
                  console.log(e);
                }}
                onClick={() => {
                  setIsModalOpen(true);
                  setIsOne(el);
                }}
                className=" p-1 w-[100%] flex flex-row justify-between items-center text-stone-900 text-bold  cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 "
              >
                <div className="w-[50%]">
                  <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">
                    {el.id}- {el.name}
                  </p>
                  <h2
                    className="text-[14px] shrink text-[#6b7280] p-0 m-0 w-[100px] truncate "
                    // style={{
                    //   overflow: "hidden",
                    //   textOverflow: "ellipsis",
                    //   whiteSpace: "nowrap",
                    // }}
                  >
                    {el?.comment}
                  </h2>
                </div>
                <div className="flex flex-col items-end">
                  <p className="text-[14px] text-[#6b7280]  p-0 m-0">
                    <Tooltip
                      sx={{ fontSize: "10px" }}
                      className="text-[14px]"
                      title={`yaratildi: ${el?.created_at} \n updated: ${el?.updated_at}`}
                    >
                      {moment(el.date).format("DD.MM.YYYY")}
                    </Tooltip>
                  </p>
                  <p className="text-[14px] text-[#6b7280]  p-0 m-0">
                    qop: {(el.tonna * 1000) / 50}
                    Tonna: {el.tonna}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
